import { Injectable, signal, Signal, WritableSignal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ModalService {
	private modals = new Map<string, WritableSignal<boolean>>();

	public registerModal(key: string) {
		this.modals.set(key, signal(false));
	}

	public openModal(key: string) {
		this.modals.get(key).set(true);
	}

	public closeModal(key: string) {
		this.modals.get(key).set(false);
	}

	public toggleModal(key: string) {
		this.modals.get(key).update((v) => !v);
	}

	public getModalSignal(key: string) {
		return this.modals.get(key);
	}
}
